import React from 'react'
import { Withdrawal } from 'src/core/models'
import { CustomTitle } from 'src/components'
import { useAppSelector } from 'src/app/hooks'
import { currencyListSelector } from 'src/features'
import { getFormatedPrice } from 'src/core/helpers'

interface WithdrawalTotalColumnProps { withdrawal: Withdrawal }

const WithdrawalTotalColumn: React.FC<WithdrawalTotalColumnProps> = ({ withdrawal }) => {
  const currencyList = useAppSelector(currencyListSelector)
  const currencyCode = currencyList.find(c => c.id === withdrawal.currency_token_id)?.code

  return <CustomTitle label={getFormatedPrice(withdrawal.total, currencyCode)} />
}

export default WithdrawalTotalColumn
